import { Box } from '@mui/material';
import { useState } from 'react';
import RemoveCountryConfirmationModal from './RemoveCountryConfirmationModal/RemoveCountryConfirmationModal';
import CountryList from './CountryList/CountryList';
import usePlanStore from '../../../../../store/planStore';
import CountryPanel from './CountryPanel/CountryPanel';
import ClearFormDialog from './CountryPanel/ClearFormDialog/ClearFormDialog';
import NestedCountryTabs from './NestedCountryTabs/NestedCountryTabs';
import StartHereTooltip from './StartHereTooltip/StartHereTooltip';

export default function Countries() {
  const {
    selectedCountry,
    setSelectedCountry,
    removeCountry,
    countryForms,
    setSelectedCountryISOCode,
    updateCountryForm,
    resetSavedCountryForm,
    resetCountryFormConfig,
    isLocked,
  } = usePlanStore();

  const [tabToRemove, setTabToRemove] = useState<string | null>(null);
  const [isClearFormDialogOpen, setIsClearFormDialogOpen] = useState(false);

  const confirmRemoveTab = () => {
    if (!tabToRemove) return;
    removeCountry(tabToRemove);
    const remainingCountries = Object.keys(
      usePlanStore.getState().countryForms
    );
    if (selectedCountry === tabToRemove) {
      if (remainingCountries.length > 0) {
        setSelectedCountry(remainingCountries[0]);
        setSelectedCountryISOCode(remainingCountries[0]);
      } else {
        setSelectedCountry(null);
        setSelectedCountryISOCode(null);
      }
    }

    resetCountryFormConfig(selectedCountry!);
    resetSavedCountryForm(selectedCountry!);
    setTabToRemove(null); // Reset the modal state
  };

  const handleCloseClearFormDialog = () => {
    setIsClearFormDialogOpen(false);
  };

  const handleProceedClearFormDialog = () => {
    if (selectedCountry) {
      updateCountryForm(selectedCountry, {
        targetGroup: '',
        campaignScenario: '',
        segments: [],
        startDate: '',
        campaignLength: '',
        isCountrySetupConfirmed: false,
      });

      resetSavedCountryForm(selectedCountry!);
      resetCountryFormConfig(selectedCountry!);
      setIsClearFormDialogOpen(false);
    }
  };

  return (
    <Box display="flex" height="100%">
      <CountryList setTabToRemove={setTabToRemove} />
      <Box
        sx={{
          flex: 1,
          pl: '16px',
          mt: '16px',
        }}
      >
        {selectedCountry === null ? (
          <Box
            sx={{
              display: 'flex',
              height: '100%',
            }}
          >
            <StartHereTooltip />
          </Box>
        ) : (
          <Box>
            <Box
              sx={{
                pointerEvents: isLocked ? 'none' : 'auto',
                opacity: isLocked ? 0.6 : 1,
              }}
            >
              <CountryPanel
                country={selectedCountry}
                setIsClearFormDialogOpen={setIsClearFormDialogOpen}
              />
            </Box>
            {countryForms[selectedCountry]?.isCountrySetupConfirmed && (
              <NestedCountryTabs />
            )}
          </Box>
        )}
      </Box>

      <RemoveCountryConfirmationModal
        open={!!tabToRemove}
        onClose={() => setTabToRemove(null)}
        onConfirm={confirmRemoveTab}
      />
      <ClearFormDialog
        onClose={handleCloseClearFormDialog}
        onSuccess={handleProceedClearFormDialog}
        open={isClearFormDialogOpen}
        text="Are you sure you want to clear this form?"
      />
    </Box>
  );
}
